<div class="container-fluid">

  <div class="header-container">
    <div *ngIf="rentalsConfigured && !loadingConfig" class="page-header">
      {{ 'bikeshop.shop_setup.header.reservation_summary' | translate }}
    </div>

    <div *ngIf="!rentalsConfigured && !loadingConfig" class="page-header">
      Setup Wizard
    </div>
  </div>


  <div #checklistContainer class="checklistContainer">

  </div>
  <div *ngIf="!rentalsConfigured && !loadingConfig" class="not-configured">
    <div><span><img class="centre-launch-image" src="../../../../assets/hubtiger-rocket-start.png" /></span></div>

    <div class="welcome-text h2">Welcome to Hubtigers Rental Software</div>
    <div class="welcome-scubtext p">To get started setting up your rental store, click on the setup wizard below</div>
  </div>


  <div *ngIf="loadingConfig" style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>

  <div *ngIf="rentalsConfigured">
    <div class="sticky-container" #stickyContainer>
      <div class="date-header-container" *ngIf="!isSearch">
        <div class="left-container">
          <button type="button" class="fc-Day-button fc-button fc-button-primary"
            [ngClass]="{'fc-button-active': dateRangeView === 'DAY'}"
            (click)="viewChanged('DAY')">{{'bikeshop.calendar.day' | translate}}</button>
          <button type="button" class="fc-Day-button fc-button fc-button-primary"
            [ngClass]="{'fc-button-active': dateRangeView === 'WEEK'}"
            (click)="viewChanged('WEEK')">{{'bikeshop.calendar.week' | translate}}</button>
          <button type="button" class="fc-Day-button fc-button fc-button-primary"
            [ngClass]="{'fc-button-active': dateRangeView === 'MONTH'}"
            (click)="viewChanged('MONTH')">{{'bikeshop.calendar.month' | translate}}</button>
          <button type="button" class="fc-Day-button fc-button fc-button-primary"
            [ngClass]="{'fc-button-active': dateRangeView === 'ALLACTIVE'}"
            (click)="viewChanged('ALLACTIVE')">{{'bikeshop.rentals.summary.all_active' | translate}}</button>

        </div>
        <div class="date-container" *ngIf="dateRangeView !== 'ALLACTIVE'">
          <div><span (click)="previousDate()" class="pi pi-chevron-left"></span></div>
          <div *ngIf="dateRangeView === 'DAY'">
            <p-calendar #cal [(ngModel)]="selectedDate" [showOtherMonths]="false" (onSelect)="dateChanged($event)"
              [dateFormat]="'D, M d yy'"></p-calendar>
          </div>
          <div *ngIf="dateRangeView !== 'DAY'" class="date-range-text">
            {{fromDate | date : "EEE, MMM dd yyyy"}} - {{getToDate() | date : "EEE, MMM dd yyyy"}}
          </div>
          <div><span (click)="nextDate()" class="pi pi-chevron-right"></span></div>
        </div>
        <div class="right-container" >
          <button type="button" class="fc-Day-button fc-button fc-button-primary" *ngIf="dateRangeView !== 'ALLACTIVE'"
            (click)="setToday()">{{'bikeshop.calendar.today' | translate}}</button>
          <button type="button" class="create-reservation"
            (click)="addNewReservation()">{{'bikeshop.rentals.summary.new_reservation' | translate}}</button>
        </div>
      </div>

      <div class="rental-summary-header-action-container">

        <div class="content">
          <div>
            <!-- <div class="filter-header">{{'bikeshop.rentals.summary.filters_header' | translate}}</div> -->
            <div class="rental-summary-filters">
              <div class="search-container">
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon" (click)="getReservationsSummary()"><i
                      class="fa fa-search"></i></span>
                  <input pInputText #searchtextbox type="text" 
                    [(ngModel)]="searchRequest"
                    placeholder="{{ 'general.search' | translate}}" 
                    (keydown.enter)="getReservationsSummary()"
                    (ngModelChange)="onSearchInputChange($event)">
                    <!-- (ngModelChange)="searchRequest === '' && getReservationsSummary()"> -->
                </div>
              </div>

              <div class="dropdown-container">
                <p-multiSelect [options]="statuses" [(ngModel)]="selectedStatusFilter" [showClear]="false"
                  (onChange)="applyRentalFilters()" [showToggleAll]="false" [showHeader]="false" optionLabel="label"
                  optionValue="value" [disabled]="statuses.length === 0"
                  placeholder="{{'bikeshop.rentals.summary.filters.filter_by_status' | translate}}">
                </p-multiSelect>
              </div>

              <div class="dropdown-container">
                <p-multiSelect [options]="categoryFilters" [(ngModel)]="selectedCategoryFilter" [showClear]="false"
                  (onChange)="applyRentalFilters()" [showToggleAll]="false" [showHeader]="false"
                  [disabled]="categoryFilters.length === 0 || summaries.length === 0"
                  placeholder="{{'bikeshop.rentals.summary.filters.filter_by_category' | translate}}">
                </p-multiSelect>
              </div>

              <div class="dropdown-container">
                <p-multiSelect [options]="brandFilters" [(ngModel)]="selectedBrandFilter" [showClear]="false"
                  (onChange)="applyRentalFilters()" [showToggleAll]="false" [showHeader]="false"
                  [disabled]="brandFilters.length === 0  || summaries.length === 0"
                  placeholder="{{'bikeshop.rentals.summary.filters.filter_by_brand' | translate}}">
                </p-multiSelect>
              </div>

              <div class="dropdown-container">
                <p-multiSelect [options]="paymentStatuses" [(ngModel)]="selectedPaymentStatusFilter" [showClear]="false"
                  (onChange)="applyRentalFilters()" [showToggleAll]="false" [showHeader]="false" optionLabel="label"
                  optionValue="value" [disabled]="statuses.length === 0"
                  placeholder="{{'bikeshop.rentals.summary.filters.filter_by_payment_status' | translate}}">
                </p-multiSelect>
              </div>

              <div class="dropdown-container">
                <p-multiSelect [options]="waiverStatuses" [(ngModel)]="selectedWaiverStatusFilter" [showClear]="false"
                  (onChange)="applyRentalFilters()" [showToggleAll]="false" [showHeader]="false" optionLabel="label"
                  optionValue="value" [disabled]="statuses.length === 0"
                  placeholder="{{'bikeshop.rentals.summary.filters.filter_by_waiver_status' | translate}}">
                </p-multiSelect>
              </div>

              <button pButton (click)="clearFilters()" [disabled]="!isFiltersSet()"
                class="iso-round-button iso-secondary"
                label="{{ 'bikeshop.rentals.summary.filters.clear_filters' | translate }}"></button>

            </div>
          </div>
        </div>

        <!-- <button pButton (click)="addNewReservation()" class="iso-round-button"
          label="{{'bikeshop.rentals.summary.new_reservation' | translate}}"></button> -->
      </div>
    </div>

    <div style="margin-top: -32px;">
      <div style="width: 100%;">

        <div class="margin-top-16" *ngIf="isSearch">
          <app-rental-reservation-summary-detail [reservationData]="searchDataFiltered" [loading]="loading"
            InOrOut="SEARCH" [categories]="categories" [brands]="brands" [sizes]="sizes"
            [rentalStoreRules]="rentalStoreRules"
            (reload)="getReservationsSummary(false)"></app-rental-reservation-summary-detail>
        </div>

        <div *ngIf="!isSearch">
          <div>
            <app-rental-reservation-summary-detail [reservationData]="rentalDeliveriesFiltered" [loading]="loading"
              InOrOut="DELIVERIES" [categories]="categories" [brands]="brands" [sizes]="sizes"
              [rentalStoreRules]="rentalStoreRules"
              (reload)="getReservationsSummary(false)"></app-rental-reservation-summary-detail>
          </div>

          <div class="margin-top-16">
            <app-rental-reservation-summary-detail [reservationData]="rentalsGoingOutFiltered" [loading]="loading"
              InOrOut="OUT" [categories]="categories" [brands]="brands" [sizes]="sizes"
              [rentalStoreRules]="rentalStoreRules"
              (reload)="getReservationsSummary(false)"></app-rental-reservation-summary-detail>
          </div>

          <div class="margin-top-16">
            <app-rental-reservation-summary-detail [reservationData]="rentalCollectionsFiltered" [loading]="loading"
              InOrOut="COLLECTIONS" [categories]="categories" [brands]="brands" [sizes]="sizes"
              [rentalStoreRules]="rentalStoreRules"
              (reload)="getReservationsSummary(false)"></app-rental-reservation-summary-detail>
          </div>

          <div class="margin-top-16">
            <app-rental-reservation-summary-detail [reservationData]="rentalsReturningFiltered" [loading]="loading"
              InOrOut="IN" [categories]="categories" [brands]="brands" [sizes]="sizes"
              [rentalStoreRules]="rentalStoreRules"
              (reload)="getReservationsSummary(false)"></app-rental-reservation-summary-detail>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<p-sidebar #NavSideBar [(visible)]="showBookRentalReservation" position="right"
  (onHide)="NavSideBar.destroyModal();closeNewReservation()" [autoZIndex]="false"
  [style]="{width:'950px', background: '#FAFAFA', 'overflow-x': 'auto','z-index': '1001'}">
  <div *ngIf="showBookRentalReservation">
    <app-book-rental-reservation [bookingInfo]="bookingInfo" (close)="closeNewReservation()" [categories]="categories"
      [brands]="brands" [sizes]="sizes" [rentalStoreRules]="rentalStoreRules"></app-book-rental-reservation>
  </div>
</p-sidebar>